import React from 'react'

// Redux
import { connect } from 'react-redux'

const DEFAULT_LAT = 37.773972
const DEFAULT_LNG = -122.431297

class LocationManager extends React.PureComponent {

  componentWillMount(){
    this.startLocationGathering()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.getLocation !== nextProps.getLocation
      && nextProps.getLocation === 'grant'){
      this.getUserPosition()
    }
  }

  startLocationGathering = () => {
    if (this.userLocationIsEmpty() && navigator.permissions){
      navigator
      .permissions
      .query({name:'geolocation'})
      .then((result) => {
        if (result.state == 'granted') {
          this.getUserPosition()
        }
      })
    }
  }

  userLocationIsEmpty = () => {
    const { userLocation } = this.props
    if (userLocation
        && userLocation.lat
        && userLocation.lng){
          return false
        } else {
          return true
        }
  }

  getUserPosition = () => {
    const position = {}
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          if (pos.coords
              && pos.coords.latitude
              && pos.coords.longitude){
              this.setUserPosition(pos.coords.latitude, pos.coords.longitude)
          } else {
            this.setUserPosition(DEFAULT_LAT, DEFAULT_LNG)
          }
        },
        (err) => {this.setUserPosition(DEFAULT_LAT, DEFAULT_LNG)})
    } else {
      //set default
      this.setUserPosition(DEFAULT_LAT, DEFAULT_LNG)
    }
  }

  setUserPosition = (lat, lng) => {
    const position = {}
    position['lat'] = lat
    position['lng'] = lng
    this.props.dispatch({
      type: 'UPDATE_USER_LOCATION',
      value: position
    })
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    userLocation: state.userSettings.location,
    getLocation: state.uiDialogs['GET_LOCATION'],
  }
};
export default connect(mapStateToProps)(LocationManager)



// WEBPACK FOOTER //
// ./src/infra/components/LocationManager.js